import { Link, useLocation } from "react-router-dom";

export type CompanyTab = "model" | "documents" | "runs";

export function companyTabFromPath(
  pathname: string,
  companyId: string,
): CompanyTab {
  const base = `/companies/${encodeURIComponent(companyId)}`;
  if (pathname === `${base}/documents`) return "documents";
  if (pathname === `${base}/runs` || pathname.startsWith(`${base}/runs/`)) {
    return "runs";
  }
  return "model";
}

export default function CompanyTabs({ companyId }: { companyId: string }) {
  const { pathname } = useLocation();
  const base = `/companies/${encodeURIComponent(companyId)}`;
  const activeTab = companyTabFromPath(pathname, companyId);
  const tabs: Array<{ id: CompanyTab; label: string; to: string }> = [
    { id: "model", label: "Published models", to: base },
    { id: "documents", label: "Documents", to: `${base}/documents` },
    { id: "runs", label: "Runs", to: `${base}/runs` },
  ];

  return (
    <nav className="company-tabs" aria-label="Company sections">
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          to={tab.to}
          className={activeTab === tab.id ? "is-active" : undefined}
          aria-current={activeTab === tab.id ? "page" : undefined}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
